// ../../../utils/finalForm/validators/VALIDATOR_MINLENGTH.js
export const VALIDATOR_MINLENGTH = (min) => (value) =>
  value && value.length < min
    ? `Must be at least ${min} characters.`
    : undefined;
